import { DateTime } from "luxon";

export function formattedDate(date) {
  
    if (!date) return "";
    let d;
  
    // Regular expressions to match the different date formats
    const rfc2822Regex = /^\w{3}, \d{1,2} \w{3} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \(.+\)$/;
    const shortDateRegex = /^\d{4}-\d{2}-\d{2}$/; // ISO format (YYYY-MM-DD)
  
    // Check for RFC 2822 format
    if (rfc2822Regex.test(date)) {
      d = DateTime.fromRFC2822(date);
    } 
    // Check for ISO date format
    else if (shortDateRegex.test(date)) {
      d = DateTime.fromISO(date);
    } 
    // For other string formats,  parsing  using Luxon
    else {
      d = DateTime.fromJSDate(new Date(date)); // Fallback to JS Date parsing
    }
  
    // Validate the DateTime object
    if (!d.isValid) {
      console.error("Invalid date format:", date);
      return "Invalid date"; // Handle invalid date
    }
  
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedDate = d.toLocaleString(options);
 
  
    return formattedDate; 
  }
